import Storage from '@comm/utils/storagehandle'
const state = {
  agencyInfo: Storage.getItem('agencyInfo') || null,
  agencyProgram: Storage.getItem('agencyProgram') || null
}

const getters = {
  agencyInfo: state => state.agencyInfo,
  agencyProgram: state => state.agencyProgram
}

const actions = {

}

const mutations = {
  MATCH_CHANGE_AGENCY_INFO (state, data) {
    state.agencyInfo = data
    Storage.setItem(`agencyInfo`, state.agencyInfo)
  },
  MATCH_CHANGE_AGENCY_PROGRAM (state, data) {
    state.agencyProgram = data
    Storage.setItem(`agencyProgram`, state.agencyProgram)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/district/store/modules/agency.js